export enum GatewayService {
  WEATHER_HUB = 'weather-hub',
  SENSOR_HUB = 'sensor-hub',
}
